import { ScrollProvider, Header } from '@/components'
import { ParallaxProvider } from "react-scroll-parallax";
import { Toaster } from "react-hot-toast";
import PagesRouter from '@/router/pages'

// Standalone marketing pages (/company, /contact-us) run on real paths under a
// BrowserRouter, mounted by src/index.tsx when window.location.pathname starts
// with /company or /contact-us. They are prerendered to static HTML at build
// time (see scripts/prerender-pages.js) so crawlers get full content + meta.
function PagesApp() {
  return (
    <ParallaxProvider>
      <ScrollProvider>
        <Header />
        <PagesRouter />
        <Toaster />
      </ScrollProvider>
    </ParallaxProvider>
  );
}

export default PagesApp;
